import Table from '@/common/Table';

const TimeIntervalFooter = ({ loading }) => {
  return (
    <Table.Row>
      <Table.Cell className="text-end" colSpan={10}>
        {loading && (
          <span className="text-muted">
            <i className="fas fa-spinner fa-pulse" />
          </span>
        )}
      </Table.Cell>
    </Table.Row>
  );
};

export default TimeIntervalFooter;
